document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Hero slider ---------- */
  document.querySelectorAll('[data-hero-slider]').forEach(function (slider) {
    var slides = slider.querySelectorAll('[data-hero-slide]');
    var dots = slider.querySelectorAll('[data-hero-dot]');
    if (slides.length < 2) return;

    var current = 0;
    var autoplay = slider.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(slider.getAttribute('data-autoplay-speed'), 10) || 6000;
    var timer;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      dots[current] && dots[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      dots[current] && dots[current].classList.add('is-active');
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = setInterval(next, speed);
    }
    function stopAutoplay() { if (timer) clearInterval(timer); }

    var nextBtn = slider.querySelector('[data-hero-next]');
    var prevBtn = slider.querySelector('[data-hero-prev]');
    nextBtn && nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
    prevBtn && prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); startAutoplay(); });
    });

    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);

    /* basic swipe support */
    var touchStartX = 0;
    slider.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      var diff = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(diff) > 40) { diff < 0 ? next() : prev(); startAutoplay(); }
    }, { passive: true });

    startAutoplay();
  });

  /* ---------- Mobile menu ---------- */
  var menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  var menuClose = document.querySelector('[data-mobile-menu-close]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () {
      mobileMenu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (menuClose && mobileMenu) {
    menuClose.addEventListener('click', function () {
      mobileMenu.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  /* ---------- Sticky header shadow (optional, purely visual) ---------- */
  var header = document.querySelector('[data-site-header]');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 10) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    }, { passive: true });
  }

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOverlay = document.querySelector('[data-cart-overlay]');
  var cartOpeners = document.querySelectorAll('[data-cart-open]');
  var cartClosers = document.querySelectorAll('[data-cart-close]');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartOverlay && cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartOverlay && cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  cartOpeners.forEach(function (el) { el.addEventListener('click', function (e) { e.preventDefault(); openCart(); }); });
  cartClosers.forEach(function (el) { el.addEventListener('click', closeCart); });
  cartOverlay && cartOverlay.addEventListener('click', closeCart);

  async function refreshCartDrawer() {
    if (!cartDrawer) return;
    try {
      var res = await fetch('/?section_id=cart-drawer');
      var html = await res.text();
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var newDrawer = doc.querySelector('[data-cart-drawer-inner]');
      var current = document.querySelector('[data-cart-drawer-inner]');
      if (newDrawer && current) current.innerHTML = newDrawer.innerHTML;
      updateCartCount();
      bindCartLineEvents();
    } catch (err) { /* silent */ }
  }

  async function updateCartCount() {
    try {
      var res = await fetch('/cart.js');
      var cart = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
      });
    } catch (err) { /* silent */ }
  }

  window.AlkhairCart = {
    async addItem(id, quantity) {
      quantity = quantity || 1;
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: quantity }] })
        });
        await refreshCartDrawer();
        openCart();
      } catch (err) { /* silent */ }
    },
    async changeLine(line, quantity) {
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: quantity })
        });
        await refreshCartDrawer();
        if (document.querySelector('[data-cart-page]')) window.location.reload();
      } catch (err) { /* silent */ }
    }
  };

  function bindCartLineEvents() {
    document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        window.AlkhairCart.changeLine(btn.getAttribute('data-cart-remove'), 0);
      });
    });
    document.querySelectorAll('[data-cart-qty-decrease]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = btn.getAttribute('data-cart-qty-decrease');
        var input = document.querySelector('[data-cart-qty-input="' + line + '"]');
        var val = Math.max(0, parseInt(input.value || '1', 10) - 1);
        window.AlkhairCart.changeLine(line, val);
      });
    });
    document.querySelectorAll('[data-cart-qty-increase]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = btn.getAttribute('data-cart-qty-increase');
        var input = document.querySelector('[data-cart-qty-input="' + line + '"]');
        var val = parseInt(input.value || '1', 10) + 1;
        window.AlkhairCart.changeLine(line, val);
      });
    });
  }
  bindCartLineEvents();
  updateCartCount();

  /* ---------- Add to cart forms (product page + quick add) ---------- */
  document.querySelectorAll('[data-add-to-cart-form]').forEach(function (form) {
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      var idInput = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      if (!idInput) return;
      var submitBtn = form.querySelector('[data-add-to-cart-submit]');
      if (submitBtn) { submitBtn.disabled = true; }
      await window.AlkhairCart.addItem(idInput.value, qtyInput ? parseInt(qtyInput.value, 10) : 1);
      if (submitBtn) { submitBtn.disabled = false; }
    });
  });

 /* ---------- Luxury COD Order Popup ---------- */

(function () {

  var codModal = document.querySelector('[data-cod-modal]');
  if (!codModal) return;

  var codForm = codModal.querySelector('[data-cod-form]');
  var closeButtons = codModal.querySelectorAll('[data-cod-close]');
  var whatsappButton = codModal.querySelector('[data-cod-whatsapp]');

  var productTitle = codModal.querySelector('[data-cod-product-title]');
  var productImage = codModal.querySelector('[data-cod-product-image]');
  var productPrice = codModal.querySelector('[data-cod-product-price]');
  var subtotal = codModal.querySelector('[data-cod-subtotal]');
  var total = codModal.querySelector('[data-cod-total]');
  var buttonTotal = codModal.querySelector('[data-cod-button-total]');
  var quantityText = codModal.querySelector('[data-cod-qty]');
  var quantityInput = codModal.querySelector('[data-cod-quantity]');
  var variantInput = codModal.querySelector('[data-cod-variant-id]');

  var currentProduct = {
    title: '',
    price: 0,
    image: '',
    variantId: '',
    quantity: 1,
    variantTitle: ''
  };

  /* ---------- Money formatter ---------- */

  function formatMoney(cents) {

    cents = Number(cents) || 0;

    return 'Rs. ' + Math.round(cents / 100).toLocaleString('en-PK');

  }


  /* ---------- Get product variant data ---------- */

  function getVariantData(form) {

    if (!form) return null;

    var idInput = form.querySelector('[name="id"]');

    if (!idInput) return null;

    var variantId = String(idInput.value);

    var variantJson = form.querySelector('[data-variant-json]');

    if (variantJson) {

      try {

        var variants = JSON.parse(variantJson.textContent);

        var found = variants.find(function (variant) {
          return String(variant.id) === variantId;
        });

        if (found) return found;

      } catch (error) {
        console.error('Variant JSON error:', error);
      }

    }

    return null;

  }


  /* ---------- Open COD popup ---------- */

  function openCodModal(button) {

    var form = button.closest('form');

    if (!form) return;

    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');

    if (!idInput) return;


    var variant = getVariantData(form);

    var quantity = qtyInput
      ? Math.max(1, parseInt(qtyInput.value || '1', 10))
      : 1;


    /* Product title */

    currentProduct.title =
      document.querySelector('.product-info h1')?.textContent.trim() ||
      button.getAttribute('data-product-title') ||
      '';


    /* Variant ID */

    currentProduct.variantId = idInput.value;


    /* Quantity */

    currentProduct.quantity = quantity;


    /* Variant title */

    currentProduct.variantTitle = '';

    if (variant && variant.options) {
      currentProduct.variantTitle = variant.options.join(' / ');
    }


    /* REAL PRICE FROM SHOPIFY */

    if (variant && variant.price !== undefined) {

      currentProduct.price = Number(variant.price);

    } else {

      /*
       * Fallback:
       * Get price directly from product page
       */

      var priceElement =
        document.querySelector('[data-product-price]');

      if (priceElement) {

        var rawPrice =
  priceElement.textContent
    .replace(/[^\d.]/g, '');

/*
 * Shopify money is in cents.
 */

currentProduct.price =
  Math.round(Number(rawPrice) * 100);

      } else {

        currentProduct.price = 0;

      }

    }


    /* Product image */

    var mainImage =
      document.querySelector('[data-gallery-main-img]');

    if (variant && variant.featured_image) {

      currentProduct.image =
        variant.featured_image;

    } else if (mainImage) {

      currentProduct.image =
        mainImage.src;

    }


    /* Update popup */

    if (productTitle) {
      productTitle.textContent =
        currentProduct.title;
    }

    if (productImage && currentProduct.image) {
      productImage.src =
        currentProduct.image;
    }

    if (productPrice) {
      productPrice.textContent =
        formatMoney(currentProduct.price);
    }

    if (quantityText) {
      quantityText.textContent =
        currentProduct.quantity;
    }

    if (quantityInput) {
      quantityInput.value =
        currentProduct.quantity;
    }

    if (variantInput) {
      variantInput.value =
        currentProduct.variantId;
    }


    updateCODTotal();


    codModal.classList.add('is-open');

    codModal.setAttribute(
      'aria-hidden',
      'false'
    );

    document.body.style.overflow = 'hidden';


    var firstInput =
      codForm &&
      codForm.querySelector(
        'input[name="first_name"]'
      );

    setTimeout(function () {

      if (firstInput) {
        firstInput.focus();
      }

    }, 250);

  }


  /* ---------- Update subtotal / total ---------- */

  function updateCODTotal() {

    var quantity =
      quantityInput
        ? Math.max(
            1,
            parseInt(quantityInput.value || '1', 10)
          )
        : currentProduct.quantity;


    currentProduct.quantity =
      quantity;


    var calculatedTotal =
      Number(currentProduct.price) *
      quantity;


    var formatted =
      formatMoney(calculatedTotal);


    if (subtotal) {
      subtotal.textContent =
        formatted;
    }

    if (total) {
      total.textContent =
        formatted;
    }

    if (buttonTotal) {
      buttonTotal.textContent =
        formatted;
    }

    if (quantityText) {
      quantityText.textContent =
        quantity;
    }


    updateWhatsApp();

  }


  /* ---------- Close popup ---------- */

  function closeCodModal() {

    codModal.classList.remove('is-open');

    codModal.setAttribute(
      'aria-hidden',
      'true'
    );

    document.body.style.overflow = '';

  }


  /* ---------- Open button ---------- */

  document.querySelectorAll('[data-buy-now]').forEach(function (button) {

    button.addEventListener('click', function (event) {

      event.preventDefault();

      if (button.disabled) return;

      openCodModal(button);

    });

  });


  /* ---------- Close buttons ---------- */

  closeButtons.forEach(function (button) {

    button.addEventListener('click', function () {

      closeCodModal();

    });

  });


  /* ---------- ESC ---------- */

  document.addEventListener('keydown', function (event) {

    if (
      event.key === 'Escape' &&
      codModal.classList.contains('is-open')
    ) {

      closeCodModal();

    }

  });


  /* ---------- Quantity update ---------- */

  document.addEventListener('click', function (event) {

    if (
      event.target.closest('[data-qty-plus]') ||
      event.target.closest('[data-qty-minus]')
    ) {

      setTimeout(function () {

        updateCODTotal();

      }, 50);

    }

  });


  /* ---------- Quantity input ---------- */

  if (quantityInput) {

    quantityInput.addEventListener(
      'input',
      updateCODTotal
    );

    quantityInput.addEventListener(
      'change',
      updateCODTotal
    );

  }


  /* ---------- Customer information ---------- */

  function updateWhatsApp() {

    if (!whatsappButton || !codForm) return;

    var formData =
      new FormData(codForm);


    var firstName =
      formData.get('first_name') || '';

    var lastName =
      formData.get('last_name') || '';

    var phone =
      formData.get('phone') || '';

    var address =
      formData.get('address') || '';

    var province =
      formData.get('province') || '';

    var city =
      formData.get('city') || '';


    var totalAmount =
      formatMoney(
        currentProduct.price *
        currentProduct.quantity
      );


    var message =
      'Assalamualaikum Alkhair,%0A%0A' +

      '*New COD Order*%0A%0A' +

      'Product: ' +
      encodeURIComponent(
        currentProduct.title
      ) +

      '%0A' +

      'Quantity: ' +
      currentProduct.quantity +

      '%0A' +

      'Total: ' +
      encodeURIComponent(
        totalAmount
      ) +

      '%0A%0A' +

      '*Customer Details*%0A' +

      'Name: ' +
      encodeURIComponent(
        firstName + ' ' + lastName
      ) +

      '%0A' +

      'Phone: ' +
      encodeURIComponent(phone) +

      '%0A' +

      'Address: ' +
      encodeURIComponent(address) +

      '%0A' +

      'City: ' +
      encodeURIComponent(city) +

      '%0A' +

      'Province: ' +
      encodeURIComponent(province);


    whatsappButton.href =
      'https://wa.me/923007769921?text=' +
      message;

  }


  /* Update WhatsApp whenever customer types */

  if (codForm) {

    codForm.addEventListener(
      'input',
      updateWhatsApp
    );

  }


  /* ---------- Complete COD Order ---------- */

  if (codForm) {

    codForm.addEventListener(
      'submit',
      async function (event) {

        event.preventDefault();


        var submitButton =
          codForm.querySelector(
            '.cod-complete-btn'
          );


        if (!submitButton) return;


        submitButton.disabled = true;

        submitButton.textContent =
          'PROCESSING ORDER...';


        var formData =
          new FormData(codForm);


        var firstName =
          formData.get('first_name') || '';

        var lastName =
          formData.get('last_name') || '';

        var phone =
          formData.get('phone') || '';

        var address =
          formData.get('address') || '';

        var province =
          formData.get('province') || '';

        var city =
          formData.get('city') || '';


        try {

          /* Save customer information */

          await fetch(
            '/cart/update.js',
            {
              method: 'POST',

              headers: {
                'Content-Type':
                  'application/json'
              },

              body: JSON.stringify({

                attributes: {

                  'Customer Name':
                    firstName +
                    ' ' +
                    lastName,

                  'Customer Phone':
                    phone,

                  'Delivery Address':
                    address,

                  'Province':
                    province,

                  'City':
                    city,

                  'Order Type':
                    'Cash on Delivery'

                }

              })

            }
          );


          /* Add product to cart */

          await fetch(
            '/cart/add.js',
            {
              method: 'POST',

              headers: {
                'Content-Type':
                  'application/json'
              },

              body: JSON.stringify({

                items: [{

                  id:
                    currentProduct.variantId,

                  quantity:
                    currentProduct.quantity

                }]

              })

            }
          );


          /* Checkout — customer ki details pehle se bhar dein */

var checkoutParams = new URLSearchParams();
checkoutParams.set('checkout[shipping_address][first_name]', firstName);
checkoutParams.set('checkout[shipping_address][last_name]', lastName);
checkoutParams.set('checkout[shipping_address][address1]', address);
checkoutParams.set('checkout[shipping_address][city]', city);
checkoutParams.set('checkout[shipping_address][province]', province);
checkoutParams.set('checkout[shipping_address][country]', 'Pakistan');
checkoutParams.set('checkout[shipping_address][phone]', phone);

window.location.href =
  '/checkout?' + checkoutParams.toString();


        } catch (error) {

          console.error(
            'COD order error:',
            error
          );


          submitButton.disabled =
            false;


          submitButton.textContent =
            'COMPLETE ORDER — ' +
            (
              buttonTotal
                ? buttonTotal.textContent
                : ''
            );


          alert(
            'Order process mein problem aa gayi. Please dobara try karein.'
          );

        }

      }
    );

  }


})();

  /* ---------- Quantity selectors (product page) ---------- */
  document.querySelectorAll('[data-quantity-selector]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var minus = wrap.querySelector('[data-qty-minus]');
    var plus = wrap.querySelector('[data-qty-plus]');
    minus && minus.addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    plus && plus.addEventListener('click', function () {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });

  /* ---------- Product gallery ---------- */
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main-img]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (main && full) main.src = full;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- Variant selection -> price/id sync ---------- */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var selects = picker.querySelectorAll('select[data-option-index], [data-swatch-group]');
    var variantDataEl = picker.querySelector('[data-variant-json]');
    if (!variantDataEl) return;
    var variants;
    try { variants = JSON.parse(variantDataEl.textContent); } catch (e) { return; }

    function getSelectedOptions() {
      var opts = [];
      picker.querySelectorAll('[data-option-position]').forEach(function (group) {
        var pos = parseInt(group.getAttribute('data-option-position'), 10);
        var val;
        var select = group.querySelector('select');
        if (select) { val = select.value; }
        else {
          var active = group.querySelector('.swatch.is-active');
          val = active ? active.getAttribute('data-value') : null;
        }
        opts[pos - 1] = val;
      });
      return opts;
    }

    function findVariant() {
      var opts = getSelectedOptions();
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function updateUI() {
      var variant = findVariant();
      var idInput = document.querySelector('[data-selected-variant-id]');
      var priceEl = document.querySelector('[data-product-price]');
      var compareEl = document.querySelector('[data-product-compare-price]');
      var available = variant.available;

if (buyBtn) {
  buyBtn.disabled = false;
  buyBtn.removeAttribute('disabled');
}

if (addBtn) {
  addBtn.disabled = !available;
}
      if (!variant) {
        if (buyBtn) buyBtn.disabled = true;
        if (addBtn) addBtn.disabled = true;
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price_formatted;
      if (compareEl) {
        if (variant.compare_at_price_formatted && variant.compare_at_price > variant.price) {
          compareEl.textContent = variant.compare_at_price_formatted;
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      var available = variant.available;
      if (buyBtn) buyBtn.disabled = !available;
      if (addBtn) addBtn.disabled = !available;
      var mainImg = document.querySelector('[data-gallery-main-img]');
      if (mainImg && variant.featured_image) mainImg.src = variant.featured_image;
    }

    picker.querySelectorAll('[data-option-position] select').forEach(function (s) {
      s.addEventListener('change', updateUI);
    });
    picker.querySelectorAll('.swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var group = swatch.closest('[data-option-position]');
        group.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('is-active'); });
        swatch.classList.add('is-active');
        updateUI();
      });
    });
    updateUI();
  });

  /* ---------- Accordions ---------- */
  document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('.accordion-item');
      item.classList.toggle('is-open');
    });
  });

  /* ---------- Search drawer ---------- */
  var searchDrawer = document.querySelector('[data-search-drawer]');
  document.querySelectorAll('[data-search-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      searchDrawer && searchDrawer.classList.add('is-open');
      var input = searchDrawer && searchDrawer.querySelector('input[type="search"]');
      input && input.focus();
    });
  });
  document.querySelectorAll('[data-search-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      searchDrawer && searchDrawer.classList.remove('is-open');
    });
  });

  /* ---------- Predictive search ---------- */
  var predictiveInput = document.querySelector('[data-predictive-search-input]');
  var predictiveResults = document.querySelector('[data-predictive-search-results]');
  var predictiveTimer;
  if (predictiveInput && predictiveResults) {
    predictiveInput.addEventListener('input', function () {
      clearTimeout(predictiveTimer);
      var term = predictiveInput.value.trim();
      if (term.length < 2) {
        predictiveResults.classList.remove('is-open');
        predictiveResults.innerHTML = '';
        return;
      }
      predictiveTimer = setTimeout(async function () {
        try {
          var res = await fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6');
          var data = await res.json();
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) {
            predictiveResults.innerHTML = '<div class="predictive-search-item">No results found</div>';
          } else {
            predictiveResults.innerHTML = products.map(function (p) {
              return '<a class="predictive-search-item" href="' + p.url + '">' +
                (p.image ? '<img src="' + p.image + '" alt="">' : '') +
                '<span>' + p.title + '</span></a>';
            }).join('');
          }
          predictiveResults.classList.add('is-open');
        } catch (err) { /* silent */ }
      }, 250);
    });
  }

  /* ---------- Newsletter ---------- */
  document.querySelectorAll('[data-newsletter-form]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var msg = form.querySelector('[data-newsletter-message]');
      if (msg) { msg.textContent = ''; }
    });
  });

});
